module.exports = __webpack_public_path__ + "static/media/square-root-alt.8c0a6dfb.svg";